// user.reducer.js
import { useReducer } from "react";
import * as ACTION from "./types";

const initialState = {
  isLoading: false,
  showLeftMenu: false,
  aiMaturityEval: null,
  revenueReport: null,
  companyInfoSaved: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.UPDATE_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ACTION.UPDATE_LEFT_MENU:
      return {
        ...state,
        showLeftMenu: action.payload,
      };
    case ACTION.GET_AI_MATURITY_EVALUATION:
      return {
        ...state,
        aiMaturityEval: action.payload,
      };
    case ACTION.UPDATE_COMPANY_INFO_STATUS:
      return {
        ...state,
        companyInfoSaved: action.payload,
      };
    case ACTION.UPDATE_REVENUE_REPORT:
      return {
        ...state,
        revenueReport: action.payload,
      };
    default:
      return state;
  }
};

const useAppReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
};

export default useAppReducer;
